export const CONTACT_EMAIL_COOKIE = '_ce';
export const CUSTOMER_ORDER_COUNT_COOKIE = '_co';
export const USER_EMAIL_COOKIE = '_e';
